export function transformErrorApi(errResp) {
  let errors = "";

  // Handle undefined errors
  if (errResp.status === undefined && errResp.error === undefined) {

    if (window && window['Sentry']) {
      window['Sentry'].captureMessage(errResp);
    }

    return 'Wystąpił nieoczekiwany błąd.';
  }

  // Handle server errors (5xx)
  if (errResp.status >= 500) {
    return 'Wystąpił błąd serwera. Spróbuj ponownie za chwilę.';
  }

  // Handle client errors
  if (errResp.status !== 0) {
    try {
      // if native xhr response
      if (!errResp.error) {
        errResp.error = JSON.parse(errResp.response);
      }

      let jsonBody = errResp.error;

      // Handle errors in main object
      if (jsonBody?.errors?.errors) {
        jsonBody.errors.errors.forEach((error) => {
          errors += error + '<br/>';
        });
      }

      // Handle errors in children
      if (jsonBody?.errors?.children) {
        for (let key in jsonBody.errors.children) {
          const childErrors = jsonBody.errors.children[key]?.errors;
          if (childErrors) {
            childErrors.forEach((error) => {
              if (dictionaryError[key]) {
                errors += (dictionaryError[key] || key) + ': ';
              }
              errors += error + '<br/>';
            });
          }
        }
      }

      // Fallback to message if no other errors
      if (errors.length === 0 && jsonBody?.message) {
        errors += jsonBody.message + '<br/>';
      }

    } catch (parseError) {
      console.error('Error parsing response:', parseError);
      return 'Wystąpił błąd podczas przetwarzania odpowiedzi serwera.';
    }
  }

  // Fallback for remaining cases (502, 0, etc.)
  return errors || 'Wystąpił błąd połączenia. Sprawdź połączenie internetowe.';
}

export const dictionaryError = {
  'first_name': 'Imię',
  'last_name': 'Nazwisko',
  'old_password': 'Aktualne hasło',
  'new_password': 'Nowe hasło',
  'email': 'E-mail',
  'firstName': 'Imię',
  'lastName': 'Nazwisko',
  'pesel': 'Pesel',
  'phone': 'Nr telefonu',
  'password': 'Hasło',
  'hrid': 'HRID',
  'challenge': 'Pierwsze hasło',
  'code': 'Kod',
  'company': 'Firma',
  'handler': 'Opiekun ME',
  'department': 'Dział',
  'registrationNumber': 'Nr rejestracyjny',
  'people': 'Pasażerowie',
};
